import { Form } from "@amzn/aquila-feedback-web-assets";
import type { FC } from "react";
import React, { useEffect, useState } from "react";
import { useStore } from "zustand";

import { useGetReportIssueForm } from "../../hooks/aquila/reportIssue/useGetReportIssueForm/useGetReportIssueForm";
import { useSubmitReportIssueForm } from "../../hooks/aquila/reportIssue/useSubmitReportIssueForm/useSubmitReportIssueForm";
import { authStore } from "../../store/auth";
import { AquilaReportIssueTriggerType } from "../../types/aquila";
import { isSuccess } from "../../utils/api.utils";

interface YourInsightsReportIssueProps {
    onComponentReady?: (callback: {
        setIsReportIssueOpen: (isFeedbackFormOpen: boolean) => void;
    }) => void;
}

const InternalReportIssue: FC = ({
    onComponentReady,
}: YourInsightsReportIssueProps) => {
    const [aquilaConfig] = useStore(authStore, (state) => [
        state.settings.aquilaConfig,
    ]);
    const [
        formConfig,
        getReportIssueFormConfigAsyncStatus,
        getFormConfigAsyncAction,
    ] = useGetReportIssueForm({
        reportIssueFormConfig: aquilaConfig.yourInsightsTabReportIssueConfig,
    });
    const [isReportIssueOpen, setIsReportIssueOpen] = useState(false);
    const [, submitFormAsyncAction] = useSubmitReportIssueForm({
        reportIssueFormConfig: aquilaConfig.yourInsightsTabReportIssueConfig,
        trigger: AquilaReportIssueTriggerType.YOUR_INSIGHT_DECKS_TAB,
    });

    const handleOnSubmit = (formData) => {
        void submitFormAsyncAction.execute(formData);
        setIsReportIssueOpen(false);
    };

    const handleOnCancel = () => {
        setIsReportIssueOpen(false);
    };

    useEffect(() => {
        if (aquilaConfig.yourInsightsTabReportIssueConfig?.configId) {
            void getFormConfigAsyncAction.execute();
        }
    }, []);

    useEffect(() => {
        if (onComponentReady) {
            onComponentReady({
                setIsReportIssueOpen,
            });
        }
    }, [onComponentReady]);

    return isSuccess(getReportIssueFormConfigAsyncStatus) && formConfig ? (
        <>
            {isReportIssueOpen && (
                <Form
                    {...formConfig}
                    configId={
                        aquilaConfig.yourInsightsTabReportIssueConfig.configId
                    }
                    onSubmit={handleOnSubmit}
                    onCancel={handleOnCancel}
                    isOpen={isReportIssueOpen}
                />
            )}
        </>
    ) : (
        <></>
    );
};

export const YourInsightsReportIssue =
    React.memo<YourInsightsReportIssueProps>(InternalReportIssue);
